import React from 'react';

export type Row = Record<string, string | number>;
export type Column = { key: string; label: string; align?: 'left' | 'right' };

type Props = {
  columns: Column[];
  rows: Row[];
  /** Forces a consistent grid across blocks (default 3 to match design) */
  totalCols?: number;
  className?: string;
};

export const GridTable: React.FC<Props> = ({ columns, rows, totalCols = 3, className = '' }) => {
  const paddedCols: Column[] = [...columns];
  while (paddedCols.length < totalCols) {
    paddedCols.push({ key: `__empty_${paddedCols.length}`, label: '' });
  }

  return (
    <div className={`w-full ${className}`}>
      <div
        className="grid w-full gap-y-2 text-sm"
        style={{ gridTemplateColumns: `repeat(${totalCols}, minmax(0, 1fr))` }}
      >
        {paddedCols.map((c) => (
          <div
            key={`h-${c.key}`}
            className={`text-slate-400 ${c.align === 'right' ? 'text-right' : ''}`}
          >
            {c.label}
          </div>
        ))}

        {rows.map((r, ri) =>
          paddedCols.map((c, ci) => (
            <div
              key={`r-${ri}-${c.key}-${ci}`}
              className={`font-normal text-white ${c.align === 'right' ? 'text-right' : ''}`}
            >
              {r[c.key] ?? ''}
            </div>
          )),
        )}
      </div>
    </div>
  );
};

export default GridTable;
